import * as i0 from "@angular/core";
import * as i1 from "./storage.token";
export class StorageService {
    constructor(localStorage) {
        this.localStorage = localStorage;
    }
    get(key) {
        return JSON.parse(this.localStorage.getItem(key));
    }
    set(key, value) {
        this.localStorage.setItem(key, JSON.stringify(value));
    }
    remove(key) {
        this.localStorage.removeItem(key);
    }
}
StorageService.ngInjectableDef = i0.defineInjectable({ factory: function StorageService_Factory() { return new StorageService(i0.inject(i1.STORAGE)); }, token: StorageService, providedIn: "root" });
